/* global window, jQuery */

// Added for Split.io... and promises are nice to have all the time
require('core-js/fn/promise');
require('core-js/fn/object/values');
require('bootstrap/scss/bootstrap.scss');
require('public/css/main.scss');
require('owl.carousel/dist/assets/owl.carousel.css');
const NumberFormat = require('@revolutionparts/number-format')();
const Geolocation = require('public/js/api/geolocation')({ window });
const get = require('lodash/get');

// Setup our faux ajax handler so plugin can take over if necessary
window.$ajax = window.$ajax || jQuery.ajax;

// Assign jquery to our internal rp$ variable
// In the plugin case, be more careful about not clobbering existing $'s
if (window.__IS_WEBSTORE_PLUGIN) {
	window.rp$ = jQuery.noConflict();
} else {
	window.rp$ = jQuery;
}

// Set up global RP app object
window.rp_app = require('public/js/app');
window.rp_app.activeMakes = [];
window.rp_app.priceFormat = function(price) {
	return NumberFormat.currency(price);
};
window.rp_app.request = require('public/js/lib/request');


// When NOT in plugin mode...
if (!window.__IS_WEBSTORE_PLUGIN) {
	// Handle Error events
	window.addEventListener('error', window.rp_app.logger.handleErrorEvent, true);
	// Expose normal jquery globals
	window.jQuery = window.$ = window.rp$;
}

// Load 3rd Party Plugins
// 3rd party plugins can rely on gobal window.jQuery object, which we aren't guaranteed to have
(function (RPjQuery) {
	const tempJQ = window.jQuery; // Step 1: Take current jquery global and associate with a temp var
	window.jQuery = RPjQuery;     // Step 2: Replace global jquery object with rp$

	// BEGIN 3rd Party Plugin Load
	// require('select2/dist/js/select2.min.js');
	require('owl.carousel');

	require('bootstrap/js/dist/carousel');
	require('bootstrap/js/dist/collapse');
	require('bootstrap/js/dist/popover');
	require('bootstrap/js/dist/modal');
	require('bootstrap/js/dist/tab');
	if (!window.__IS_WEBSTORE_PLUGIN) {
		// Including bootstrap dropdown breaks DDC (EX: https://www.landroverchicago.com/parts-store.htm)
		require('bootstrap/js/dist/dropdown');
	}
	// END 3rd Party Plugin load

	window.jQuery = tempJQ;       // Step 3: Restore original jquery global
})(window.rp$);

// JQuery Plugins
require('public/js/components/vehicle-picker');
require('public/js/components/cart');

require('public/js/elements/email-addresses');
require('public/js/elements/overlay-spinner');
//Wishlist Actions
const wishlist = require('public/js/components/wishlist');
// Auto suggest
require('public/js/components/input-suggestions');

const searchBox = require('public/js/components/search-box');
const contactable = require('public/js/elements/contactable');
const flyouts = require('public/js/elements/flyouts');
const $onReady = require('public/js/lib/on-ready');
const lazyLoad = require('public/js/lib/image-lazy-load')();

const onReady = function () {
	const isIframedPage = get(rp_app, 'data.plugin_iframe_page') || false;

	/* Attach Lazy Load Intersection To Images/BG Images
	.*-----------------------------------------*/
	lazyLoad.attach();

	/* Pull in active makes
	.*-----------------------------------------*/
	// NOTE: On iframed pages, this code doesn't run (is handled by parent)
	if (!isIframedPage) {
		$ajax({
			dataType: 'json',
			url: '/ajax/vehicle-picker/makes/all',
			success : function(response/*, type, xhr*/) {
				window.rp_app.activeMakes = response;
			},
		});
	}
	flyouts.attachEvents();

	/* Bootstrap
	.*-----------------------------------------*/
	rp$('.carousel').carousel();

	/* Call vehiclepicker on select elements
	.*-----------------------------------------*/
	rp$('.vehiclepicker_classic, .vehiclepicker').vehiclepicker({});
	rp$('.vehiclepicker_link, .vehiclepicker-link').vehiclepicker_link();

	/* Add to Cart
	.*-----------------------------------------*/
	rp$('.add-to-cart.enabled').add_to_cart();

	if (window.__IS_WEBSTORE_PLUGIN) {
		wishlist.attachEvents();
	}

	/* Fix email address
	.*-----------------------------------------*/
	rp$('.email-address').emailAddress();
	contactable.attach();

	/* Add Popover
	.*-----------------------------------------*/
	rp$('.popover-tooltip').popover({
		trigger: 'hover',
		placement: 'bottom'
	});

	searchBox.setupSearchBox();

	// Set browser location (contains lat/long only) if ip-location not cached [Currently Lead-Gen Only]
	// NOTE: On iframed pages, this code doesn't run (is handled by parent)
	if (!isIframedPage) {
		Geolocation.setBrowserLocation();
	}
};

module.exports = () => {
	$onReady({fn: onReady, rp$, window, label: 'main'});
};
